import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { StyledSmallEditor } from './CreateCompaign.styles';
import { SlEnergy } from "react-icons/sl";
import { SPINTAX_TEMPLATES } from '../../Constant';



const SmallEditor = ({
  value,
  onChange,
  hideToolbar,
  onlyLink = false,
  onlyVariable = false,
  withVariables = false,
  placeholder,

}) => {
  const editorRef = useRef(null);
  const commonStyle = `
    body {
      margin: 0 !important;
      padding: 12px 0 !important;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
    }
    p {
      margin: 0 0 4px 0 !important;
    }
           a{
        cursor: pointer;
      }
  `;

  const onlyLinkStyle = `
    body {
      margin: 0 !important;
      font-family: "DM Sans", sans-serif;
      font-size: 14px;
    }
    p {
      margin:  4px 0 !important;
    }
    .mce-content-body [data-mce-selected="inline-boundary"] {
      background-color: transparent !important;
    }
      a{
        cursor: pointer;
      }

  `;



  const variableOnlyInit = {
    menubar: false,
    statusbar: false,
    placeholder: 'Insert greeting with variables...',
    toolbar: hideToolbar ? false : 'variables',
    branding: false,
    plugins: [],
    quickbars_selection_toolbar: false,
    quickbars_insert_toolbar: false,
    contextmenu: false,
    content_style: onlyLinkStyle,



    setup: (editor) => {
      editor.ui.registry.addIcon(
        'energyIcon',
        `<svg viewBox="0 0 24 24" width="18" height="18"
              style="fill:none !important; stroke:currentColor !important; stroke-width:2;"
              stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2L3 14h9l-1 8 10-12h-9z"
                  style="fill:none !important; stroke:currentColor !important;"/>
         </svg>`
      );

      const predefinedFields = ['first_name', 'last_name'];

      editor.ui.registry.addMenuButton('variables', {
        icon: 'energyIcon',
        tooltip: 'Insert Variable',
        fetch: (callback) => {
          const menuItems = predefinedFields.map((key) => ({
            type: 'menuitem',
            text: `{{${key}}}`,
            onAction: () => {
              editor.insertContent(`{{${key}}}`);
            },
          }));

          callback(menuItems);
        },
      });
    }
  };
  const onlyLinkInit = {
    menubar: false,
    statusbar: false,
    placeholder: 'Enter Call To Action',
    toolbar: hideToolbar ? false : 'link',
    plugins: ['link'],
    branding: false,
    quickbars_selection_toolbar: false,
    quickbars_insert_toolbar: false,
    contextmenu: false,
    content_style: onlyLinkStyle,
  };

  const spintaxSetup = editor => {
    editor.ui.registry.addMenuButton('spintax', {
      text: 'Spintax',
      fetch: callback => {
        const menuItems = SPINTAX_TEMPLATES?.map(template => ({
          type: 'menuitem',
          text: template.label,
          onAction: () => {
            editor.insertContent(template.content);
          },
        }));

        callback(menuItems);
      },
    });
  };

  const variablesSetup = (editor) => {
    editor.ui.registry.addIcon(
      'energyIconFull',
      `<svg viewBox="0 0 24 24" width="18" height="18"
            style="fill:none !important; stroke:currentColor !important; stroke-width:2;"
            stroke-linecap="round" stroke-linejoin="round">
          <path d="M13 2L3 14h9l-1 8 10-12h-9z"
                style="fill:none !important; stroke:currentColor !important;"/>
       </svg>`
    );
    editor.ui.registry.addMenuButton('variables', {
      icon: 'energyIconFull',
      tooltip: 'Insert Variable',
      fetch: (callback) => {
        const fields = ['first_name', 'last_name', 'company_name', 'job_title', 'location'];
        callback(fields.map(key => ({
          type: 'menuitem',
          text: `{{${key}}}`,
          onAction: () => editor.insertContent(`{{${key}}}`),
        })));
      },
    });
    spintaxSetup(editor);
  };

  const fullInit = {
    menubar: false,
    statusbar: false,
    height: 220,
    placeholder: 'Create your email signature...',
    toolbar: hideToolbar
      ? false
      : 'undo redo | formatselect | bold italic underline forecolor backcolor | alignleft aligncenter alignright | bullist numlist | link image | spintax | removeformat',
    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'image',
      'charmap',
      'preview',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'table',
      'paste',
      'help',
      'wordcount',
    ],
    file_picker_types: 'image',
    // file_picker_callback: (cb, value, meta) => {
    //   if (meta.filetype === 'image') {
    //     const input = document.createElement('input');
    //     input.type = 'file';
    //     input.accept = 'image/*';

    //     input.onchange = function () {
    //       const file = this.files[0];
    //       if (file) {
    //         const maxSize = 100 * 1024; // 100KB
    //         if (file.size > maxSize) {
    //           Toast({
    //             type: 'error',
    //             message: 'Image size must be less than 100KB.',
    //           });
    //           return;
    //         }

    //         const reader = new FileReader();
    //         reader.onload = () => {
    //           cb(reader.result, { title: file.name });
    //         };
    //         reader.readAsDataURL(file);
    //       }
    //     };

    //     input.click();
    //   }
    // },
    setup: spintaxSetup,
    content_style: commonStyle,
  };

  const emailBodyInit = {
    menubar: false,
    statusbar: false,
    height: 270,
    placeholder: placeholder || 'Write your email body here...',
    toolbar_mode: 'sliding',
    toolbar: hideToolbar
      ? false
      : 'undo redo | bold italic underline | forecolor backcolor | variables spintax | alignleft aligncenter alignright | bullist numlist | link  | removeformat',
    plugins: ['advlist', 'autolink', 'lists', 'link', 'charmap', 'searchreplace', 'wordcount'],
    setup: variablesSetup,
    content_style: commonStyle,
    z_index: 99999,
    link_assume_external_targets: true,
    link_default_protocol: 'https',
  };

  return (
    <StyledSmallEditor>
      <Editor
        apiKey="3v80rwqhpqj0r6x4kbc780fzud8p1ssm0uzelnn1vjavhbus"
        value={value}
        onEditorChange={(newValue) =>
          onChange?.({ target: { value: newValue } })
        }
        init={
          onlyVariable
            ? variableOnlyInit
            : onlyLink
              ? onlyLinkInit
              : withVariables
                ? emailBodyInit
                : fullInit
        }
        onInit={(evt, editor) => (editorRef.current = editor)}
      />
    </StyledSmallEditor>
  );
};

export default SmallEditor;